import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import CalendarDialog from "../../calendarDialog/CalendarDialog";
import UpperCaseText from "../../../../../utils/UpperCaseText";
import { CASH, CASH_OPTIONS } from "../../../../../common/Constants";
import styles from "./CashOptions.module.scss";
import HasPermissionTo from "../../../../../common/HasPermissionTo";
import LowerCaseText from "../../../../../utils/LowerCaseText";
import CheckBox from "../../../../../shared/checkBox/CheckBox";
import UiDateUtils from "../../../../../utils/UiDateUtils";
import checkboxStyles from "../../../../../shared/checkBox/CheckBox.module.scss";
import CapitalizeText from "../../../../../utils/CapitalizeText";
import CheckBoxDialog from "../../../../../shared/checkBoxDialog/CheckBoxDialog";

const ItemDetails = ({ date, description }) => {
  return (
    <div className={styles.info}>
      <span className={styles.paymentInfo}>
        {UiDateUtils.formattedDate(date)}
      </span>
      {description}
    </div>
  );
};

class CashOptions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openPaymentWindow: false,
    };
    this.hasCompletedAcceptOrder = false;
    this.hasCompletedPaymentWindow = false;
    this.hasCompletedFullPayment = false;
    this.canEditPaymentMethod =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "paymentMethod:write"
      );
    this.canOpenPaymentWindow =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "paymentWindow:write"
      );
    this.showFullCashOptions =
      LowerCaseText(this.props.paymentType) === CASH ||
      CASH_OPTIONS.ONLINE_APPROVED_MARKETS.includes(
        UpperCaseText(this.props.selectedMarket)
      );
  }

  onConfirmCashPaymentWindow = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const formattedDate = UiDateUtils.formatDateYYYYMMDD(year, month, day);
    this.saveCashOption(
      UiDateUtils.saveDateFormat(formattedDate),
      "paymentwindowopen"
    );
    this.openPaymentWindow();
  };

  openPaymentWindow = () => {
    this.setState((prevState) => ({
      openPaymentWindow: !prevState.openPaymentWindow,
    }));
  };

  checkHasCompletedPreviousActions() {
    const customerReservation = this.props.customerReservation;
    this.hasCompletedAcceptOrder =
      customerReservation.acceptTheOrderData &&
      customerReservation.acceptTheOrderData.dealerAcceptedDate &&
      customerReservation.acceptTheOrderData.dealerActionUserId;
    this.hasCompletedPaymentWindow =
      customerReservation.paymentWindowOpenedData &&
      customerReservation.paymentWindowOpenedData.dealerAcceptedDate &&
      customerReservation.paymentWindowOpenedData.dealerActionUserId;
    this.hasCompletedFullPayment =
      customerReservation.finalPaymentConfirmedData &&
      customerReservation.finalPaymentConfirmedData.dealerAcceptedDate &&
      customerReservation.finalPaymentConfirmedData.dealerActionUserId;
  }

  hasCompletedPreviousOption = (id) => {
    let previousStep = null;
    const options = CASH_OPTIONS[UpperCaseText(this.props.selectedMarket)];
    options &&
      options.forEach((item) => {
        if (item.key === id) {
          if (!item.hasPrevious) {
            previousStep = false;
          } else {
            previousStep = item.previousKey;
          }
        }
      });
    switch (previousStep) {
      case "acceptTheOrder":
        return !this.hasCompletedAcceptOrder;
      case "openPaymentWindow":
        return !this.hasCompletedPaymentWindow;
      case "customerFullPayment":
        return !this.hasCompletedFullPayment;
      default:
        return previousStep;
    }
  };

  saveCashOption = (acceptedDate, type) => {
    this.props.handleUpdateOrder(type, acceptedDate);
  };

  isAcceptOrderDisabled = () => {
    return LowerCaseText(this.props.paymentType) === CASH
      ? this.hasCompletedPreviousOption("acceptTheOrder") ||
          this.hasCompletedAcceptOrder ||
          !this.canEditPaymentMethod
      : this.hasCompletedAcceptOrder;
  };

  isCashOpenPaymentDisabled = () => {
    return LowerCaseText(this.props.paymentType) === CASH
      ? this.hasCompletedPreviousOption("openPaymentWindow") ||
          this.hasCompletedPaymentWindow ||
          !this.canOpenPaymentWindow
      : this.hasCompletedPaymentWindow;
  };

  isCashFullPaymentEnabled = () => {
    return LowerCaseText(this.props.paymentType) === CASH
      ? this.hasCompletedPreviousOption("customerFullPayment") ||
          this.hasCompletedFullPayment ||
          !this.canEditPaymentMethod
      : this.hasCompletedFullPayment;
  };

  render() {
    this.checkHasCompletedPreviousActions();
    return (
      <div>
        {/*Cash will be offline*/}
        <HasPermissionTo
          perform={["cashContract:view"]}
          permissions={this.props.user.permissions.rolePermissions}
          condition={
            LowerCaseText(this.props.paymentType) === CASH ||
            CASH_OPTIONS.ONLINE_APPROVED_MARKETS.includes(
              UpperCaseText(this.props.selectedMarket)
            )
          }
          render={() => {
            return (
              <div data-testid="cashAcceptOrder">
                <div className={styles.rowContainer}>
                  <CheckBox
                    {...this.props}
                    id="acceptTheOrderCheckBoxId"
                    checked={!!this.hasCompletedAcceptOrder}
                    isDisabled={
                      this.isAcceptOrderDisabled() || !this.canEditPaymentMethod
                    }
                    label={this.props.t("PMAcceptTheOrder.acceptOrder")}
                    onChange={() => {
                      this.saveCashOption(
                        this.props.customerReservation.todayDate,
                        CASH_OPTIONS.ACCEPT_ORDER
                      );
                    }}
                    textClass={
                      this.hasCompletedPreviousOption("acceptTheOrder") ||
                      this.hasCompletedAcceptOrder
                        ? this.hasCompletedAcceptOrder
                          ? checkboxStyles.boldLabel
                          : checkboxStyles.disabledLabel
                        : checkboxStyles.boldLabel
                    }
                  />
                  {this.hasCompletedAcceptOrder && (
                    <ItemDetails
                      date={
                        this.props.customerReservation.acceptTheOrderData
                          .dealerAcceptedDate
                      }
                      description={
                        <>
                          <span className={styles.acceptGreen}>
                            {this.props.t("PMAcceptTheOrder.accepted")}
                          </span>
                          <span className={styles.detailsText}>
                            {CapitalizeText(
                              this.props.customerReservation.acceptTheOrderData
                                .dealerActionUserId
                            )}
                          </span>
                        </>
                      }
                    />
                  )}
                </div>
              </div>
            );
          }}
        />
        {this.showFullCashOptions && (
          <>
            <div data-testid="cashOpenPaymentWindow">
              <div className={styles.rowContainer}>
                <CheckBox
                  id="openPaymentWindow"
                  isDisabled={
                    this.isCashOpenPaymentDisabled() ||
                    !this.canOpenPaymentWindow
                  }
                  label={this.props.t("PMOpenPaymentWindow.label")}
                  checked={this.hasCompletedPaymentWindow}
                  onChange={this.openPaymentWindow}
                  textClass={
                    this.hasCompletedPreviousOption("cashOpenPaymentWindow") ||
                    this.hasCompletedPaymentWindow ||
                    !this.canOpenPaymentWindow
                      ? this.hasCompletedPaymentWindow
                        ? checkboxStyles.boldLabel
                        : checkboxStyles.disabledLabel
                      : checkboxStyles.boldLabel
                  }
                />
                {this.hasCompletedPaymentWindow && (
                  <ItemDetails
                    date={
                      this.props.customerReservation.paymentWindowOpenedData
                        .dealerAcceptedDate
                    }
                    description={
                      <>
                        <span className={styles.acceptGreen}>
                          {this.props.t("PMOpenPaymentWindow.released")}
                        </span>
                        <span className={styles.detailsText}>
                          {CapitalizeText(
                            this.props.customerReservation
                              .paymentWindowOpenedData.dealerActionUserId
                          )}
                        </span>
                      </>
                    }
                  />
                )}
              </div>
            </div>
            <div data-testid="cashFullPayment ">
              <div className={styles.rowContainer}>
                <CalendarDialog
                  {...this.props}
                  id="customerFullPayment"
                  saveCalendarDate={this.saveCashOption}
                  todayDate={this.props.customerReservation.todayDate}
                  type={CASH_OPTIONS.FINAL_PAYMENT_CONFIRMED}
                  checkBoxText={this.props.t("PMCashPayment.label")}
                  isDisabled={
                    this.isCashFullPaymentEnabled() ||
                    !this.canEditPaymentMethod
                  }
                  isChecked={this.hasCompletedFullPayment}
                  hasMaxDate={true}
                  dialogTitle={this.props.t("PMCashPayment.dialogHeader")}
                  dialogDescription={this.props.t(
                    "PMCashPayment.dialogDescription"
                  )}
                />
                {this.hasCompletedFullPayment && (
                  <ItemDetails
                    date={
                      this.props.customerReservation.finalPaymentConfirmedData
                        .dealerAcceptedDate
                    }
                    description={
                      <>
                        <span className={styles.acceptGreen}>
                          {this.props.t("PMCashPayment.received")}
                        </span>
                        <span className={styles.detailsText}>
                          {CapitalizeText(
                            this.props.customerReservation
                              .finalPaymentConfirmedData.dealerActionUserId
                          )}
                        </span>
                      </>
                    }
                  />
                )}
              </div>
            </div>
          </>
        )}

        <CheckBoxDialog
          open={this.state.openPaymentWindow}
          title={this.props.t("PMOpenPaymentWindow.dialogHeader")}
          text={this.props.t("PMOpenPaymentWindow.dialogDescription")}
          checkboxLabel={this.props.t("PMOpenPaymentWindow.checkboxLabel")}
          onConfirm={this.onConfirmCashPaymentWindow}
          onClose={this.openPaymentWindow}
          cancelText={this.props.t("PMOpenPaymentWindow.cancel")}
          confirmText={this.props.t("PMOpenPaymentWindow.confirm")}
        />
      </div>
    );
  }
}

export default withTranslation("emp")(CashOptions);
